import { ListGroup, ListGroupItem } from 'react-bootstrap'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'

export const getStaticProps = makeLocaleStaticProps

export const Page = () => {
  return (
    <DefaultLayout maxWidth={1000} head={{ title: `特定商取引法に基づく表記` }}>
      <div className="mathdown-monotone">
        <h1 className="mb-4">特定商取引法に基づく表示</h1>
        <ListGroup>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                法人名
              </div>
              <div>OptHub株式会社</div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                所在地
              </div>
              <div>請求があったら遅滞なく開示します。</div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                電話番号
              </div>
              <div>請求があったら遅滞なく開示します。</div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                メールアドレス
              </div>
              <div>support@mathlog.info</div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                運営統括責任者
              </div>
              <div>三嶋 隆史</div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                追加手数料等の追加料金
              </div>
              <div>
                全ての料金が商品の表示価格に含まれているのでありません。
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                交換および返品（返金ポリシー）
              </div>
              <div>
                お客様都合の返品及び交換は受け付けておりません。本サービスの不具合で購入された商品やサービスが反映されない場合は、直ちに反映させて頂きますので、上記のメールアドレスもしくはお問い合わせフォームからご連絡ください。
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                引渡期間
              </div>
              <div>
                本サイト内で購入できる商品やサービスは、本サービス内のコンテンツや機能として即座に提供されます。
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                受け付け可能な決済手段
              </div>
              <div>クレジットカードによる決済を受け付けております。</div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                決済期間
              </div>
              <div>
                定期購読のサービスや商品はそれぞれのサービスや商品の取り決めに基づいて決済されます。定期購読ではない商品やサービスの決済は即座に行われます。
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <div className="d-block d-md-flex gap-5 align-items-top">
              <div style={{ width: 300 }} className="flex-shrink-0 fw-bold">
                販売価格
              </div>
              <div>
                商品やサービスごとに異なりますので、各商品やサービスのページをご覧ください。
              </div>
            </div>
          </ListGroupItem>
        </ListGroup>
      </div>
    </DefaultLayout>
  )
}

export default Page
